import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ApiError } from '@/api/client';
import { AuthProvider } from '@/features/auth/AuthProvider';

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        }
      },
      mutations: { retry: false }
    }
  });

export const AppProviders = ({ children, client }: { children: ReactNode; client?: QueryClient }) => (
  <QueryClientProvider client={client ?? createQueryClient()}>
    <AuthProvider>{children}</AuthProvider>
  </QueryClientProvider>
);
